import DataObjectReducer from "./Reducers/DataObjectReducer";
import { combineReducers } from 'redux';
import authreducer from './Reducers/AuthReducer';
// combineReducer => 
const allReducer = combineReducers({
    dataObject: DataObjectReducer,
    authreducer
})

export default allReducer